import app from '../../../scripts/app';
import template from './contact-info.jade';
import { ContactInfoCtrl } from './ContactInfo.controller';

app.directive('cianAfContactInfo', () => {
  return {
    template,
    scope: {},
    bindToController: {
      form: '=',
      phones: '=',
      ad: '=',
    },
    controller: ContactInfoCtrl,
    controllerAs: 'contactInfoCtrl',
    replace: true,
  };
});
